import http from "plugins/axios";

export default {
  //当前委托信息列表
  getUserList(data) {
    return http.get({
      url: `/la/admin/channel/entrust/listPage`,
      data
    });
  },
  exportExcel(data) {
    return http.get({
      url: `/la/admin/channel/entrust/listPage/excel`,
      data,
      responseType: "blob",
    });
  },
  //获取交易对列表
  getSymbolList() {
    return http.get({
      url: "/la/admin/channel/common/symbolList",
    });
  },

  //获取币种列表
  getCoinList() {
    return http.get({
      url: "/channel/common/coinList",
    });
  },
};
